import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useParams, useHistory } from 'react-router-dom'
import {
  Row,
  Panel,
  IconButton,
  Icon,
  Modal,
  Button,
  Col,
  ControlLabel,
  RadioGroup,
  Radio,
  Message,
  Input,
} from 'rsuite'
import AttachFilesMakeContract from '../makeContract/AttachFilesMakeContract'
import AttachFilesView from '../makeContract/AttachFilesMakeContractView'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import EditButton from '../../components/buttons/editButton/EditButton'
import ViewButton from '../../components/buttons/viewButton/ViewButton'
import {
  getDownload,
  getAttachments,
  saveAttachments,
  updateAttachments,
  deleteAttachments,
} from '../../redux/actions/attachments'
import { startLoading, doneLoading } from '../../utils/loading'
import { getSchemaSidebar } from '../../redux/actions/sidebar'
import PdfRenderWidgets from '../pdfWidgets/PdfRenderWidgets'
import { isRequired, isValidators, isRequiredFiled } from '../../utils/ValidatorUtils'
import {
  saveAttachmentGrantee,
  deleteAttachmentGrantee,
  getAttachmentGrantee,
  updateMakeContract,
  getMakeContract,
  getDownloadAttachmentGrantee,
  getContractPdf,
  getDownloadContractPdf,
  getContractPdfSubProject,
  saveWitnessName,
} from '../../redux/actions/contract'
import ConfirmWidget from '../confirm/ConfirmWidget'
import pathname from '../../constants/pathname'
import classNames from 'classnames'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'

export default function MakeContractPanelSub(props) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues } = useForm()
  const [section, setSection] = useState()
  const [isEditErr, setIsEditErr] = useState(false)
  const [isUploadErr, setIsUploadErr] = useState(false)
  const [isDeleteError, setIsDeleteError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [showConfirm, setShowConfirm] = useState(false)
  const [contractId, setContractId] = useState('')
  const [isMakeContractError, setIsMakeContractError] = useState(false)
  const [isPdfError, setIsPdfError] = useState(false)
  const [previewPdf, setPreviewPdf] = useState()
  const [isContartFileError, setIsContartFileError] = useState(false)
  const [isGranteeFileError, setIsGranteeFileError] = useState(false)
  const [isLoadingPDF, setIsLoadingPDF] = useState(false)

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const history = useHistory()

  useEffect(() => {
    // let contractId = location.search.substring(1)
    let contractId = sessionStorage.getItem('param')?.substring(1)
    console.log('MakeContractPanel', 'contract_id: ', contractId)
    if (contractId) {
      setContractId(contractId)
    }
  }, [location.search])

  useEffect(() => {
    //handleGetDownloadContractPdf(projectId)
  }, [projectId])

  const handleGetDownloadContractPdf = async (projectId, fileName, contractId) => {
    startLoading()
    setIsLoading(true)
    setIsPdfError(false)
    setIsLoadingPDF(true)
    try {
      const response = await getContractPdf('6F6B52E1-1E7D-4D08-BCFD-20F163EF598A')

      console.log('response preview pdf', response)
      if (response) {
        setPreviewPdf(response)
        setIsPdfError(false)
      } else {
        setIsPdfError(true)
      }
    } catch (e) {
      setIsPdfError(true)
    }
    setIsLoading(false)
    setIsLoadingPDF(false)
    doneLoading()
  }

  const handleUpdateMakeContract = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsMakeContractError(false)
    try {
      const response = await saveWitnessName(request, request.projectVersionId)
      console.log('res ', response)
      if (response.success) {
        const resFile = await getContractPdfSubProject(request.projectVersionId)

        // setPreviewPdf(resFile)
        onDownloadContractAndProposalFile(resFile)
        if (resFile) {
          setIsLoading(false)
          doneLoading()
        } else {
          setIsMakeContractError(true)
        }
      }

      setShowConfirm(false)
    } catch (e) {
      console.log('e', e)
      setIsMakeContractError(true)
      setShowConfirm(false)
    }
    setShowConfirm(false)
    setIsLoading(false)
    doneLoading()
  }

  const onDownloadContractAndProposalFile = async (fileObj) => {
    startLoading()
    try {
      var file = fileObj

      const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileObj.name || 'เอกสารสัญญา')
      document.body.appendChild(link)
      link.click()
      setIsContartFileError()
    } catch (e) {
      setIsContartFileError('ดาวน์โหลด')
    }
    doneLoading()
  }

  const onSubmit = (data) => {
    let request = {
      id: contractId,
      projectVersionId: projectId,
      userId: '',
      witnessName: data.witnessName,
    }

    handleUpdateMakeContract(request)
  }

  return (
    <>
      <Panel header={formSchema.panelText} bordered collapsible defaultExpanded shaded>
        {formSchema?.witnessName && (
          <Row>
            <Col xs={24} sm={24} md={24} lg={24}>
              <ControlLabel
                className={classNames(isRequired(formSchema.witnessName.validators) && 'required')}
              >
                {formSchema.witnessName.label}
              </ControlLabel>
              <ErrorMessage error={errors.witnessName} />
              <Input
                placeholder={formSchema.witnessName.hint}
                defaultValue={formSchema.witnessName.value}
                name={formSchema.witnessName.name}
                inputRef={register(isValidators(formSchema.witnessName.validators))}
              />
            </Col>
          </Row>
        )}

        {showCommandButton && <hr />}

        {isMakeContractError && (
          <Message showIcon type="error" description={formSchema.buttonText + `ไม่สำเร็จ`} />
        )}

        {showCommandButton && (
          <IconButton
            appearance="ghost"
            icon={<Icon icon="download" className="bt-gost-icon-radius"></Icon>}
            onClick={handleSubmit(onSubmit)}
          >
            {formSchema.buttonText}
          </IconButton>
        )}
      </Panel>
    </>
  )
}
